import { passwordRegex } from '@/utils/regex'
import { z } from 'zod'

export const forgetPasswordSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Invalid email address'),
})

export type ForgetPasswordSchemaType = z.infer<typeof forgetPasswordSchema>

export const resetPasswordSchema = z
  .object({
    code: z.string().length(6, 'OTP must be 6 digits'),
    password: z
      .string()
      .min(1, 'New password is required')
      .regex(passwordRegex, 'Password must be at least 8 characters, include at least one letter and one number'),
    confirmPassword: z
      .string()
      .min(1, 'Confirm password is required')
      .regex(passwordRegex, 'Password must be at least 8 characters, include at least one letter and one number'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  })

export type ResetPasswordSchemaType = z.infer<typeof resetPasswordSchema>
